import { render, staticRenderFns } from "./EmptyIncidentIcon.vue?vue&type=template&id=06f9e494"
import script from "./EmptyIncidentIcon.vue?vue&type=script&lang=js"
export * from "./EmptyIncidentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports